<template>
  <div id="dash-sidebar" @click="closeControlsidebar(controlsidebarDisp)">
	  <aside class="main-sidebar">
	    <section class="sidebar">
	      <div class="user-panel">
          <template v-if="$router.match('profileimg').name !== '404'">
            <router-link :to="{ name: 'profileimg' }" class="profileimg">
              <div class="pull-left image">
                <img v-if="profileimg !== ''" :src="profileimg" class="img-employee img-circle">
                <img v-if="profileimg === ''" src="~static/images/employee/no_image.png" class="img-employee img-circle">
                <div class="profile-edit img-circle"><i class="fa fa-camera"></i></div>
              </div>
            </router-link>
          </template>
          <template v-else>
            <div class="pull-left image">
              <img v-if="profileimg !== ''" :src="profileimg" class="img-employee img-circle">
              <img v-if="profileimg === ''" src="~static/images/employee/no_image.png" class="img-employee img-circle">
            </div>
          </template>
          <div class="pull-left info">
              <p>{{ currentUser.username[nowLang] }}</p>
              <p class="info-detail"><i class="fa fa-user"></i> {{ currentUser.p_coduser }}</p>
          </div>
	      </div>
        <ul class="sidebar-menu">
          <template v-for="(moduleObj, module, moduleObjIndex) in modules">
            <template v-if="moduleObj.type == 'main_menu'">
              <template v-if="moduleObj.sequence == '1'">
                <li class="header header-mini">MENU</li>
                <li class="header header-lg">{{ mainMenu[nowLang] }}</li>
              </template>
              <li :class="{ active: currModule == module }">
                <router-link :to="{ name: module }" @click.native="closeSidebarMobile()">
                  <i class="fa" :class="moduleObj.icon"></i> 
                  <span>{{ moduleObj.name[nowLang] }}</span>
                </router-link>
              </li>
            </template>
            <template v-if="moduleObj.type == 'ess' || (moduleObj.type == 'mss' && (module != 'managerapprove' || (module == 'managerapprove' && moduleObj.codapp.approve.length > 0)))">
              <template v-if="moduleObj.type == 'ess' && moduleObj.sequence == 1">
                <li class="header header-mini">ESS</li>
                <li class="header header-lg">{{ menuRequest[nowLang] }}</li>
              </template>
              <template v-if="moduleObj.type == 'mss' && moduleObj.sequence == 1">
                <li class="header header-mini">MSS</li>
                <li class="header header-lg">{{ menuApprove[nowLang] }}</li>
              </template>
              <dash-sidebar-menu
                :moduleObj="moduleObj"
                :module="module"
                :currModule="currModule"
                :nowLang="nowLang"
                :fontIcon="fontIcon"
                :currCodapp="currCodapp"
                :menu="menu"
                :rescale="rescale"
                :version="version"
                :pcDisp="pcDisp"
                :closeSidebarMobile="closeSidebarMobile" />
            </template>
          </template>
        </ul>  
	    </section>
	  </aside>
  </div>
</template>

<script>
import DashSidebarMenu from 'components/dash/DashSidebarMenu'

export default {
  name: 'dash-sidebar',
  components: {
    DashSidebarMenu
  },
  props: [ 'fontIcon', 'currModule', 'currCodapp', 'version', 'currentUser', 'nowLang', 'modules', 'mainMenu', 'menuRequest', 'menuApprove', 'menu', 'rescale', 'closeControlsidebar', 'controlsidebarDisp', 'pcDisp', 'closeSidebarMobile', 'profileimg' ]
}
</script>


// WEBPACK FOOTER //
// DashSidebar.vue?70cf887b